<template>
  <div>
    <el-container style="height:100vh; border: 1px solid #eee">
      <el-aside width="200px;height:100vh;">
        <div style="width: 100%">
          <LabelHeader msg="组织机构"></LabelHeader>
          <div class="buttons" style="margin: 5px 0px;">
            <el-button @click="expandAll" size="mini" plain round type="primary" style="width: 40%">展开</el-button>
            <el-button @click="foldAll" size="mini" plain round type="warning" style="width: 40%">收起</el-button>
          </div>
          <el-tree
                  :props="treeProps"
                  :highlight-current="true"
                  :default-expand-all="expandAlls"
                  :data="dataTree"
                  ref="menu"
                  node-key="id"
                  @node-click="go"
                  :expand-on-click-node="false"
          >
          </el-tree>
        </div>
      </el-aside>

      <el-main style="padding: 0px 5px;">
        <div>
          <LabelHeader :msg="preTit"></LabelHeader>
          <div style="padding: 5px 0">
            <div style="padding-left: 20px;">
              <el-form :inline="true" class="searchForm">
                <el-form-item label="名称：">
                  <el-input size="small" style="width:170px" class="ML-10" type="text" v-model="nameText" placeholder="输入名称" />
                </el-form-item>
                <el-form-item label="地址：">
                  <el-input size="small" style="width:170px" class="ML-10" type="text" v-model="addressText" placeholder="输入地址" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="mini" @click="chgeList">查询</el-button>
                </el-form-item>
              </el-form>
            </div>

            <LabelHeader msg="查询结果"></LabelHeader>

            <div class="buttonBox">
              <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="addTeam">新增</el-button>
              <el-button type="warning" size="mini" icon="el-icon-edit" @click="updateBindParam()">修改</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove()">删除</el-button>
            </div>
            <div class="table-box">
              <div class="table-border">
                <el-table
                        :data="datas"
                        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                        border
                        stripe
                        :height="elTableHeight"
                        style="width: 100%"
                        show-checkbox
                        @selection-change="handleSelectionChange"
                >
                  <af-table-column :width="40" align="center" type="selection"></af-table-column>
                  <af-table-column prop="name" label="名称" align="center"></af-table-column>
                  <af-table-column prop="holdaPost" label="在职人数" align="center"></af-table-column>
                  <af-table-column prop="resign" label="离职人数" align="center"></af-table-column>
                  <af-table-column prop="headName" label="负责人" align="center"></af-table-column>
                  <af-table-column prop="phoneNum" label="电话" align="center"></af-table-column>
                  <af-table-column prop="orderNum" label="排序" align="center"></af-table-column>
                </el-table>
              </div>
              <div class="paginationBox" v-if="pagination.total > 0">
                <el-pagination
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="pagination.total"
                        @size-change="sizeChange"
                        @current-change="currentChange"
                        :page-size="pagination.size"
                >
                </el-pagination>
              </div>
            </div>

            <el-dialog
                    v-dialogDrag
                    v-if="OpenName"
                    :title="dialogTitle"
                    :visible.sync="OpenName"
                    width="800px"
                    :modal="false"
                    :close-on-click-modal="false"
            >
              <Edit @close="close" @success="refresh" :params="editParams"></Edit>
            </el-dialog>
          </div>
        </div>

      </el-main>
    </el-container>
  </div>
</template>
<script>
import LabelHeader from "../../components/LabelHeader";
import Edit from './edit';
export default {
  data() {
    return {
      editDialogVisible: false,
      detailDialogVisible: false,
      treeProps: {//el-tree默认取数据中哪个字段
        children: 'children',
        label: 'name'
      },

      datas: [],
      elTrees: true,
      expandAlls: false,
      dialogTitle: '',
      listitem: [],
      dataTree: [],
      homeData: [{ title: '下属组织' }],
      OpenName: false,
      refreshing: false,
      addressText: null,
      nameText: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      editParams: {
        id: '',
        tree: [],
        treamName: '',
        teamId: ''
      },
      teamId: null,
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: ''
      },
      split: 0.15,
      elTableHeight: null,
      preTit: '',
      defaultChecked: ''
    };
  },
  // 页面加载获取数据
  mounted() {
    this.tree();
    window.onresize = () => {
      this.changeTableHeight();
    };
    this.changeTableHeight();
  },
  methods: {
    sizeChange(size) {
      this.pagination.size = size;
      this.list();
      this.changeTableHeight();
    },
    currentChange(pageNo) {
      this.pagination.page = pageNo;
      this.list();
    },
    changeTableHeight() {
      this.elTableHeight = null;
      let height = document.body.offsetHeight;
      if (this.datas.length === 10) {
        this.elTableHeight = null;
      } else if (this.datas.length > 10 && (this.datas.length === 20 || this.datas.length === 50 || this.datas.length === 100)) {
        this.elTableHeight = height - 416;
      } else if (this.datas.length > 10 && this.datas.length >= 14) {
        this.elTableHeight = height - 416;
      } else if (this.datas.length > 10 && this.datas.length < 14) {
        this.elTableHeight = null;
      } else if (this.datas.length < 10) {
        this.elTableHeight = null;
      } else {
        this.elTableHeight = null;
      }
    },
    expandAll() {
      this.elTrees = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    foldAll() {
      this.elTrees = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    tree() {
      httpKit.post($api_eap.team.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.dataTree = res.data.data;
            if (!this.teamId) {
              this.teamId = res.data.data[0].id;
              this.preTit = res.data.data[0].name + '下属组织';
            }
            this.list();
            treeFor(this.dataTree, 'name');
            this.$nextTick(() => {
              this.$refs.menu.setCurrentKey(this.defaultChecked);
            });
          }
        }
      });
    },
    close() {
      this.OpenName = false;
      this.editParams = {};
    },
    success() {
      this.OpenName = false;
      this.reRun();
    },
    // from表单
    handleSelectionChange(row) {
      if (row.length > 0) {
        this.listitem = row;
      }
    },
    remove() {
      deleteArr(this.listitem, $api_eap.team.delete, this.refresh);
    },
    updateBindParam() {
      if (checkSelect(this.listitem)) {
        let arr = this.listitem;
        this.dialogTitle = '编辑下属组织';
        this.OpenName = true;
        this.editParams.id = arr[0].id;
        this.editParams.tree = this.dataTree;
      }
    },
    addTeam() {
      this.dialogTitle = '新增下属组织';
      this.OpenName = true;
      this.editParams.id = null;
    },
    go(value) {
      this.teamId = value.id;
      this.defaultChecked = value.id;
      this.listitem = [];
      this.pagination.page = 1;
      this.pagination.size = 10;
      this.list();
      this.changeTableHeight();
      this.editParams.teamName = value.name;
      this.editParams.teamId = value.id;
      if (value.pid !== '-1') {
        let obj = findInTree(this.dataTree, value.pid, 'id');
        this.preTit = obj.label + ' / ' + value.label + '下属组织';
      } else {
        this.preTit = value.label + '下属组织';
      }
    },
    list(val) {
      let par = {
        pid: val || this.teamId,
        pageNo: this.pagination.page,
        pageSize: this.pagination.size
      };
      this.refreshing = true;
      this.datas = [];
      httpKit.post($api_eap.team.childrensearch, par).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.pagination.total = +res.data.totalItems;
        } else {
          if (res.data.code === '500') {
            this.datas = [];
          }
        }
      });
    },
    chgeList(value) {
      let par = {
        pageNo: value ? value.page : this.pagination.page,
        pageSize: value ? value.size : this.pagination.size,
        name: this.nameText,
        address: this.addressText
      };
      httpKit.post($api_eap.team.search, par).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.pagination.total = +res.data.totalItems;
        }
      });
    },
    refresh(val) {
      this.OpenName = false;
      this.tree();
      this.list(val);
      this.defaultChecked = val;
    },
    reRun() {
      this.pagination = {
        page: 1,
        size: 20,
        total: 0
      };
      this.tree();
    }
  },
  components: {
    Edit,LabelHeader
  }
};
</script>
<style scoped lang="less">
.el-dialog__wrapper {
  overflow: unset;
}

.rap /deep/ .el-dialog {
  width: 95%;
  overflow: auto;
  margin-top: 5vh !important;
}
.rap /deep/ .el-dialog__header {
  background: #409eff !important;
}

.rap /deep/ .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
  color: #000;
}

.buttons {
  width: 100%;
  padding-left: 10%;
  display: flex;
}
.demosplit {
  height: calc(90vh - 145px);
  overflow-y: scroll;
}
.demosplit::-webkit-scrollbar {
  width: 0;
}
.setScroll /deep/ .ivu-split-wrapper {
  overflow: hidden;
}
</style>
